import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';
const inputVariants = cva('file:text-foreground placeholder:text-muted-foreground selection:bg-primary/25 selection:text-foreground dark:bg-input/30 flex w-full min-w-0 text-base transition-[color,box-shadow] outline-none file:inline-flex file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 text-sm', {
    variants: {
        variant: {
            default: [
                'border-input h-9 rounded-md border bg-transparent px-3 py-1 shadow-xs',
                'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
            ],
            popover: [
                'h-9 rounded-none border-0 border-b border-gray-200 dark:border-border bg-gray-50/30 dark:bg-background px-3 py-2 m-0',
                'focus-visible:border-gray-300 dark:focus-visible:border-border/60 focus-visible:bg-gray-100/50 dark:focus-visible:bg-background',
                'hover:bg-gray-100/40 dark:hover:bg-background',
            ],
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
const Input = React.forwardRef(({ className, type, variant, ...props }, ref) => {
    return (_jsx("input", { type: type, "data-slot": "input", className: cn(inputVariants({ variant, className })), ref: ref, ...props }));
});
Input.displayName = 'Input';
export { Input };
//# sourceMappingURL=input.js.map